import { css, jsx } from "@emotion/react";
import styled from "@emotion/styled";
import React, { useState } from "react";
import { MOBILE_WIDTH, TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import { BuyButton, UpSaleContainer } from "./upsellStyles";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const Uppertitle = styled.div`
  font: normal normal normal 28px "Helvetica Neue";
  margin-bottom: 10px;

  @media (max-width: ${TABLET_WIDTH}) {
    margin-top: 10px;
    font-size: 24px;
  }
`;
const Maintitle = styled.div`
  font: normal normal bold 240px "Helvetica Neue";
  color: rgb(29, 20, 204);
  text-align: center;

  padding-bottom: 15px;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 140px;
  }
`;
const Subtitle = styled.div`
  font: normal normal bold 22px "Helvetica Neue";
  text-align: center;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 20px;
  }
`;

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 15%;
  padding-right: 15%;
`;

const MiddleTitle = styled.div`
  font: normal normal bold 40px "Helvetica Neue";
  color: rgb(29, 20, 204);
  text-align: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;
const Middlecontent = styled.div`
  font: normal normal bold 28px "Helvetica Neue";
  text-align: center;
  > p {
    font: normal normal normal 18px "Helvetica Neue";

    @media (max-width: ${TABLET_WIDTH}) {
      font-size: 16px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  font: normal normal normal 18px "Helvetica Neue";
  padding-left: 15%;
  padding-right: 15%;

  p > ul > li {
    padding-bottom: 15px;

    :last-child {
      padding-bottom: 0px;
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 18px;
  }
`;

const BottomNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-left: 15%;
  padding-right: 15%;
`;

const Note = styled.div`
  font-size: 18px;
  font-weight: 800;

  > p:first-child {
    font-size: 22px;
  }
`;

const ActionDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border: 5px dashed #ff644e;
  padding: 40px;
  width: 80%;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ActionTitle = styled.div`
  font: normal normal bold 23px "Helvetica Neue";
  padding-bottom: 15px;
`;
const ActionContent = styled.div`
  font-size: 16px;
`;

const NotAdd = styled.div`
  text-align: center;
  cursor: pointer;
  color: #1f1e1e;
`;

export const buyButton = css`
  margin: 15px 0px;
  width: 90%;
  border-radius: 10px;
  height: 60px;
  background-color: #64a54f;
  color: #fff;
  border-color: #fff;
  font-size: 20px;
`;
interface Props {
  onBuy: () => void;
  onNoThanks: () => void;
  isModal?: boolean;
}

export default function ContentCreation(props: Props): JSX.Element {
  const { onBuy, onNoThanks, isModal } = props;
  const [loading, setLoading] = useState(false);

  return (
    <UpSaleContainer style={{ borderRadius: "100px" }} isModal={isModal}>
      <Header>
        <Uppertitle>
          How To Create Super High-Quality Social Media Content…
        </Uppertitle>
        <Maintitle>FAST!</Maintitle>
      </Header>
      <Middle>
        <Subtitle>
          And at a thick one-time only discount from this page only — with
          BerserkerMail co-founder Troy Broussard’s hot new program (delivered
          right to your smart phone):
        </Subtitle>

        <MiddleTitle>“360º Content Creation”</MiddleTitle>
        <Middlecontent>
          <p>
            Reg price is $88.00. But you can have it from this page now for{" "}
            <span style={{ backgroundColor: "yellow" }}>just $48.00</span>
          </p>
        </Middlecontent>
      </Middle>
      <Content>
        <p>
          You can apply the info inside to your new SocialLair platform as well
          as…
          <ul>
            <li>Your Membership or Continuity Program</li>
            <li>Your Podcast</li>
            <li>Webinars and Livestreams</li>
            <li>Books and Kindles and PDFs</li>
            <li>
              And any other kind of content you want to create quickly, that is
              high quality, and that sells like hotcakes now or in the future
            </li>
          </ul>
        </p>
      </Content>
      <BottomNote>
        <Note>
          This ONE time offer vanishes like ethics the second you close this
          page.
          <p>
            <u>NOTE: You Must Have A Smart Phone To Consume This Product</u>
          </p>
          <p>
            <u>
              Also, there are no refunds on this, and all sales are final. If
              you are at-all
              <br />
              unsure you want it, please pass up on it and continue with your
              order.
            </u>
          </p>
        </Note>
        <p>Add it to your order below or continue to complete your checkout…</p>
      </BottomNote>
      <ActionDiv>
        <ActionTitle>Yeah! I'm ready!</ActionTitle>
        <ActionContent>
          I understand that there are no refunds and that all sales are final. I
          also understand that this training is only available within the mobile
          app.
        </ActionContent>
        <BuyButton
          onClick={() => {
            setLoading(true);
            onBuy();
          }}
          isLoading={loading}
        >
          Buy Now!
        </BuyButton>
        By clicking above, a total of $48.00 will be charged from your card.
      </ActionDiv>
      <NotAdd onClick={onNoThanks}>
        <b>
          <u>No thanks, please do not add this offer to my purchase.</u>
        </b>
      </NotAdd>
    </UpSaleContainer>
  );
}
